import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import theme, { textRegular } from 'theme/theme';

const MainTitle = styled.h1`
  display: block;
  padding: 0;
  margin: 0;
  font-size: ${theme.fontSizes.large};
  color: ${(props) => props.color}; 
  ${textRegular};
  line-height: 130%;
  @media (min-width: ${theme.breakpoints.tablet}) {
    font-size: ${theme.fontSizes.largeTitle};
  }
  
  ${(props) => props.withSpaceBelow && css`
    margin-bottom: 35px;
  `}
`;
MainTitle.propTypes = {
  withSpaceBelow: PropTypes.bool,
  color: PropTypes.string,
};
MainTitle.defaultProps = {
  withSpaceBelow: false,
  color: theme.colors.primary,
};

export default MainTitle;
